import { DataTable, Modal, Tag } from "components/common"
import { forwardRef, useImperativeHandle, useMemo, useRef, useState } from "react"
import { t } from "i18next"
import theme from "utils/themeVars"

const breakdownColumns = () =>[
  { title: t("Trait"), dataIndex: "trait" },
  { title: t("Feedback"), dataIndex: "feedback" },
]

const BreakdownModal = forwardRef((props, ref) => {
  const formRef = useRef()
  const [review, setReview] = useState()

  useImperativeHandle(
    ref,
    () => {
      return {
        showFor: review => {
          setReview(review)
          formRef?.current?.setVisible(true)
        },
      }
    },
    [ref]
  )

  const getTableData = useMemo(
    () =>
      review?.breakdown.map((item, index) => ({
        key: index,
        trait: item?.trait,
        feedback: (
          <>
            {item?.feedback}{" "}
            {item?.tags?.map((tag, index) => (
              <Tag color={theme["accentColor"]} shape="round" key={index}>
                {tag?.label}
              </Tag>
            ))}
            {item?.comment}
          </>
        ),
      })),
    [review]
  )

  return (
    <Modal
      title={t("Progression")}
      ref={formRef}
      width={800}
      destroyOnClose
      onCancel={() => {
        formRef?.current?.setVisible(false)
      }}
      footer={null}
      getContainer={false}
    >
      <DataTable
        columns={breakdownColumns()}
        data={getTableData || []}
        noUrlPush={false}
        offsetHeader={110}
        stickyOffset={-16}
      />
    </Modal>
  )
})

export default BreakdownModal
